import { render, staticRenderFns } from "./store-info.vue?vue&type=template&id=c5735a9a&scoped=true&"
import script from "./store-info.vue?vue&type=script&lang=ts&"
export * from "./store-info.vue?vue&type=script&lang=ts&"
import style0 from "./store-info.vue?vue&type=style&index=0&id=c5735a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5735a9a",
  null
  
)

export default component.exports